import axios from "axios";
import { APIClient } from "../../../helpers/api_helper";
import * as url from "../../../helpers/url_helper";

const api = new APIClient();

  export const createNotification = async (data) => {
      try {
        const response = await api.create(url.ADD_NOTIFICATION , data);
        return response;
      } catch (error) {
        throw error;
      }
  };

  export const getNotification = async () => {
      try {
        const response = await api.get(url.GET_NOTIFICATION);
        return response;
      } catch (error) {
        throw error;
      }
  };

  export const updateNotification = async ( id, data) => {
      try {
        const response = await axios.patch(url.UPDATE_NOTIFICATION +'/'+id, data);
        return response;
      } catch (error) {
        throw error;
      }
  };

  export const deleteNotification = async (id) => {
    try {
        const response = await api.delete(url.DELETE_NOTIFICATION +'/'+id);
        return response;
    } catch (error) {
        throw error;
    }
  };
